module.exports = __webpack_public_path__ + "img/icon-circle-success-green.7c120692.svg";